module.exports = __webpack_public_path__ + "luckycatresort-build/img/no-record.dade0a24.svg";